<template>
  <div class="basket-footer">
    <div class="flex flex-col gap-1">
      <div class="font-extralight text-sm dark:text-white">К оплате</div>
      <div class="flex flex-col">
        <span class="font-medium dark:text-white" data-testid="basket-final-amount">{{ safeFinalAmount }} ₽</span>
      </div>
    </div>

    <UTooltip :text="safeTooltipText">
      <UiButtonMain
        :loading="isLoading"
        :disabled="isDisabled"
        class="max-h-12"
        block
        :color="isDisabled ? 'gray' : 'red'"
        :label="buttonLabel"
        data-testid="basket-order-button"
        @click="handlePlaceOrder"
      />
    </UTooltip>
  </div>
</template>

<script setup lang="ts">
import { computed, unref } from 'vue'

interface Props {
  finalAmount: number
  isLoading: boolean
  isDisabled: boolean
  tooltipText: string
  buttonLabel?: string
}

interface Emits {
  (e: 'placeOrder'): void
}

const props = withDefaults(defineProps<Props>(), {
  buttonLabel: 'Оформить заказ',
})
const emit = defineEmits<Emits>()

// ✅ Безопасное получение finalAmount для SSR
const safeFinalAmount = computed(() => {
  const amount = unref(props.finalAmount)
  return typeof amount === 'number' ? amount : 0
})

// ✅ Безопасное получение tooltipText
const safeTooltipText = computed(() => {
  const text = unref(props.tooltipText)
  return typeof text === 'string' ? text : ''
})

/**
 * Обрабатывает нажатие на кнопку оформления заказа
 */
function handlePlaceOrder(): void {
  emit('placeOrder')
}
</script>

<style scoped lang="scss">
// В потоке (позиционирование/фон даёт обёртка .basketMobile__footer — закреплённый блок с блюром)
.basket-footer {
  @apply grid gap-3 grid-cols-[1fr_1.8fr] items-end p-4 px-7;
}
</style>